import { z } from 'zod';

const environmentSchema = z.enum(['dev', 'test', 'prod']);

export type Environment = z.infer<typeof environmentSchema>;

// APP_ENV is the deploy target (dev/test/prod), injected at build time from Vite's --mode.
const appEnv = environmentSchema.catch('dev').parse(process.env.APP_ENV);

export const getEnvironment = (): Environment => appEnv;

// True under `vite` serve, false in any `vite build` output. Keyed on Vite's command via
// import.meta.env.DEV rather than NODE_ENV, which a globally exported NODE_ENV (e.g. a
// machine-wide NODE_ENV=test on Windows) can override even during local dev serve.
export const isDevelopment = import.meta.env.DEV;
